export const who = [
  {
    text: "Apotheek",
    value: "Pharmacy"
  },
  {
    text: "Zorgmedewerker",
    value: "Institution"
  },
  {
    text: "(Familie van) patiënt",
    value: "Patient"
  }
];

export const addressLabelFaults = [
  {
    text: "Ontbreken adresetiket",
    value: "MissingAddressLabel",
    id: 1,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Ontbreken gegevens adresetiket",
    value: "MissingAddressLabelData",
    id: 2,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Slechte print adresetiket",
    value: "BadPrintAddressLabel",
    id: 3,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Verkeerde adresetiket",
    value: "WrongAddressLabel",
    id: 4,
    requiredFields: ["patientName", "batchNumber"]
  }
];

export const crateFaults = [
  {
    text: "Bak op verkeerde locatie bezorgd",
    value: "ReceivedCrateAtWrongLocation",
    id: 5
  },
  {
    text: "Bak te laat ontvangen",
    value: "ReceivedCrateLate",
    id: 6
  },
  {
    text: "Geen bakken ontvangen",
    value: "NotReceivedCrates",
    id: 7
  },
  {
    text: "Verkeerde bak",
    value: "WrongCrate",
    id: 8
  }
];

export const drugsFaults = [
  {
    text: "Beschadigde medicatie",
    value: "DamagedDrugs",
    id: 9,
    requiredFields: [
      "patientName",
      "swallowDate",
      "swallowTime",
      "drugNameAndStrength",
      "batchNumber",
      "bagNumber"
    ]
  },
  {
    text: "Verkeerde hoeveelheid medicatie",
    value: "WrongAmount",
    id: 10,
    requiredFields: [
      "patientName",
      "swallowDate",
      "swallowTime",
      "drugNameAndStrength",
      "batchNumber",
      "bagNumber"
    ]
  },
  {
    text: "Verkeerde medicatie",
    value: "WrongDrugs",
    id: 12,
    requiredFields: [
      "patientName",
      "swallowDate",
      "swallowTime",
      "drugNameAndStrength",
      "batchNumber",
      "bagNumber"
    ]
  }
];

export const scrollFaults = [
  {
    text: "Ontbreken rol",
    value: "MissingScroll",
    id: 13,
    requiredFields: ["patientName"]
  },
  {
    text: "Rol aan een andere rol",
    value: "ScrollAttachedToAnotherScroll",
    id: 14,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Rol met afwijking in start- en einddatum",
    value: "ScrollWithIncorrectDate",
    id: 15,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Slechte perforatie rol",
    value: "BadPerforationScroll",
    id: 16,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Slechte print rol",
    value: "BadPrintScroll",
    id: 17,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Slechte seal rol",
    value: "BadSealScroll",
    id: 18,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Te veel rollen",
    value: "ToManyScrolls",
    id: 19,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Verkeerde rol",
    value: "WrongScroll",
    id: 20,
    requiredFields: ["patientName", "batchNumber"]
  }
];

export const tdlFaults = [
  {
    text: "Ontbreken toedienlijst",
    value: "MissingTdl",
    id: 21,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Onvolledige toedienlijst",
    value: "IncompleteTdl",
    id: 22,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Slechte print toedienlijst",
    value: "BadPrintTdl",
    id: 23,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Te veel toedienlijsten",
    value: "ToManyTdl",
    id: 24,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Verkeerde toedienlijst",
    value: "WrongTdl",
    id: 25,
    requiredFields: ["patientName", "batchNumber"]
  }
];

export const packageFaults = [
  {
    text: "Beschadigde verpakking",
    value: "DamagedPackaging",
    id: 26,
    requiredFields: ["patientName", "batchNumber"]
  },
  {
    text: "Verkeerde verpakking",
    value: "WrongPackaging",
    id: 27,
    requiredFields: ["patientName", "batchNumber"]
  }
];

export const bagFaults = [
  {
    text: "Ontbreken zakje",
    value: "MissingBag",
    id: 28,
    requiredFields: ["patientName", "swallowDate", "swallowTime", "batchNumber"]
  },
  {
    text: "Slechte perforatie zakje",
    value: "BadPerforationBag",
    id: 29,
    requiredFields: [
      "patientName",
      "swallowDate",
      "swallowTime",
      "batchNumber",
      "bagNumber"
    ]
  },
  {
    text: "Slechte print zakje",
    value: "BadPringBag",
    id: 30,
    requiredFields: [
      "patientName",
      "swallowDate",
      "swallowTime",
      "batchNumber",
      "bagNumber"
    ]
  },
  {
    text: "Zakje niet goed gesloten",
    value: "BagNotClosedProperly",
    id: 31,
    requiredFields: [
      "patientName",
      "swallowDate",
      "swallowTime",
      "batchNumber",
      "bagNumber"
    ]
  }
];

export const otherFaults = [
  {
    text: "Omschrijf bij toelichting",
    value: "DescribeAtAdditionalInfo",
    id: 32
  }
];

export const subjects = [
  {
    text: "Adresetiket",
    value: "AddressLabel",
    fault: addressLabelFaults
  },
  {
    text: "Bak",
    value: "Crate",
    fault: crateFaults
  },
  {
    text: "Medicatie",
    value: "Drugs",
    fault: drugsFaults
  },
  {
    text: "Rol",
    value: "Scroll",
    fault: scrollFaults
  },
  {
    text: "Toedienlijst",
    value: "Tdl",
    fault: tdlFaults
  },
  {
    text: "Verpakking",
    value: "Packaging",
    fault: packageFaults
  },
  {
    text: "Zakje",
    value: "Bag",
    fault: bagFaults
  },
  {
    text: "Overig",
    value: "Other",
    fault: otherFaults
  }
];

export const impact = [
  {
    text: "Gebruikt, geen schade",
    value: "UsedNoDamage"
  },
  {
    text: "Gebruikt, schade",
    value: "UsedDamage"
  },
  {
    text: "Niet gebruikt, geen schade",
    value: "NotUsedNoDamage"
  },
  {
    text: "Niet gebruikt, schade",
    value: "NotUsedDamage"
  },
  {
    text: "Onbekend, geen schade",
    value: "UnknownNoDamage"
  }
];
